/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import type {
	CheckInCancelDto,
	CheckInListResponseDto,
	CheckInMutationResponseDto,
	CheckInProgressResponseDto,
	ManualCheckInDto,
	OnsiteUploadControllerDownloadTemplateV1Params,
	OnsiteUploadControllerUploadV1Body,
	OnsiteUploadControllerUploadV1Params,
	OnsiteUploadResponseDto,
	ParticipantListResponseDto,
	ReceptionAdminControllerDownloadExcelV1Params,
	ReceptionAdminControllerGetListV1Params,
	ReceptionAdminControllerGetParticipantsV1Params,
	ReceptionAdminControllerGetProgressV1Params,
	ReceptionEnterDto,
	ReceptionStateResponseDto
} from '../model';

import { axiosInstance } from '../../axiosInstance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === 'queryKey') continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key]
		});
	}
	return result;
};

/**
 * 비밀번호 없이 현재 로그인된 관리자의 리셉션 모드 상태(Redis) 조회
 * @summary 리셉션 모드 상태 조회
 */
export const receptionAdminControllerStatusV1 = (signal?: AbortSignal) => {
	return axiosInstance<ReceptionStateResponseDto>({ url: `/v1/admin/reception/status`, method: 'GET', signal });
};

export const getReceptionAdminControllerStatusV1QueryKey = () => {
	return [`/v1/admin/reception/status`] as const;
};

export const getReceptionAdminControllerStatusV1QueryOptions = <
	TData = Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>,
	TError = unknown
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getReceptionAdminControllerStatusV1QueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>> = ({ signal }) =>
		receptionAdminControllerStatusV1(signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceptionAdminControllerStatusV1QueryResult = NonNullable<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>>;
export type ReceptionAdminControllerStatusV1QueryError = unknown;

export function useReceptionAdminControllerStatusV1<TData = Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError = unknown>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerStatusV1<TData = Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError = unknown>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerStatusV1<TData = Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError = unknown>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 리셉션 모드 상태 조회
 */

export function useReceptionAdminControllerStatusV1<TData = Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError = unknown>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerStatusV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getReceptionAdminControllerStatusV1QueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 관리자 비밀번호 확인 후 리셉션 모드(8시간) 진입
 * @summary 리셉션 모드 진입
 */
export const receptionAdminControllerEnterV1 = (receptionEnterDto: ReceptionEnterDto, signal?: AbortSignal) => {
	return axiosInstance<ReceptionStateResponseDto>({
		url: `/v1/admin/reception/enter`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: receptionEnterDto,
		signal
	});
};

export const getReceptionAdminControllerEnterV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>,
		TError,
		{ data: ReceptionEnterDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>, TError, { data: ReceptionEnterDto }, TContext> => {
	const mutationKey = ['receptionAdminControllerEnterV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>,
		{ data: ReceptionEnterDto }
	> = props => {
		const { data } = props ?? {};

		return receptionAdminControllerEnterV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReceptionAdminControllerEnterV1MutationResult = NonNullable<Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>>;
export type ReceptionAdminControllerEnterV1MutationBody = ReceptionEnterDto;
export type ReceptionAdminControllerEnterV1MutationError = void;

/**
 * @summary 리셉션 모드 진입
 */
export const useReceptionAdminControllerEnterV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>,
			TError,
			{ data: ReceptionEnterDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof receptionAdminControllerEnterV1>>, TError, { data: ReceptionEnterDto }, TContext> => {
	return useMutation(getReceptionAdminControllerEnterV1MutationOptions(options), queryClient);
};
/**
 * 준비중/진행중 대회·프로그램 회차의 체크인 진행 요약 목록
 * @summary 체크인 대상 목록
 */
export const receptionAdminControllerGetListV1 = (params?: ReceptionAdminControllerGetListV1Params, signal?: AbortSignal) => {
	return axiosInstance<CheckInListResponseDto>({ url: `/v1/admin/reception/list`, method: 'GET', params, signal });
};

export const getReceptionAdminControllerGetListV1QueryKey = (params?: ReceptionAdminControllerGetListV1Params) => {
	return [`/v1/admin/reception/list`, ...(params ? [params] : [])] as const;
};

export const getReceptionAdminControllerGetListV1QueryOptions = <
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerGetListV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getReceptionAdminControllerGetListV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>> = ({ signal }) =>
		receptionAdminControllerGetListV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceptionAdminControllerGetListV1QueryResult = NonNullable<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>>;
export type ReceptionAdminControllerGetListV1QueryError = unknown;

export function useReceptionAdminControllerGetListV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
	TError = unknown
>(
	params: undefined | ReceptionAdminControllerGetListV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetListV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerGetListV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetListV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerGetListV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 체크인 대상 목록
 */

export function useReceptionAdminControllerGetListV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerGetListV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetListV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getReceptionAdminControllerGetListV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 대회/프로그램 회차의 진행률, 코스별/담당자별/시간대별 통계
 * @summary 체크인 진행률 상세
 */
export const receptionAdminControllerGetProgressV1 = (params?: ReceptionAdminControllerGetProgressV1Params, signal?: AbortSignal) => {
	return axiosInstance<CheckInProgressResponseDto>({ url: `/v1/admin/reception/progress`, method: 'GET', params, signal });
};

export const getReceptionAdminControllerGetProgressV1QueryKey = (params?: ReceptionAdminControllerGetProgressV1Params) => {
	return [`/v1/admin/reception/progress`, ...(params ? [params] : [])] as const;
};

export const getReceptionAdminControllerGetProgressV1QueryOptions = <
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetProgressV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getReceptionAdminControllerGetProgressV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>> = ({ signal }) =>
		receptionAdminControllerGetProgressV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceptionAdminControllerGetProgressV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>
>;
export type ReceptionAdminControllerGetProgressV1QueryError = void;

export function useReceptionAdminControllerGetProgressV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
	TError = void
>(
	params: undefined | ReceptionAdminControllerGetProgressV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetProgressV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetProgressV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetProgressV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetProgressV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 체크인 진행률 상세
 */

export function useReceptionAdminControllerGetProgressV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetProgressV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetProgressV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getReceptionAdminControllerGetProgressV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 체크인 참가자 명단 엑셀 파일 다운로드
 * @summary 참가자 명단 엑셀 다운로드
 */
export const receptionAdminControllerDownloadExcelV1 = (params?: ReceptionAdminControllerDownloadExcelV1Params, signal?: AbortSignal) => {
	return axiosInstance<void>({ url: `/v1/admin/reception/participants/excel`, method: 'GET', params, signal });
};

export const getReceptionAdminControllerDownloadExcelV1QueryKey = (params?: ReceptionAdminControllerDownloadExcelV1Params) => {
	return [`/v1/admin/reception/participants/excel`, ...(params ? [params] : [])] as const;
};

export const getReceptionAdminControllerDownloadExcelV1QueryOptions = <
	TData = Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerDownloadExcelV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getReceptionAdminControllerDownloadExcelV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>> = ({ signal }) =>
		receptionAdminControllerDownloadExcelV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceptionAdminControllerDownloadExcelV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>
>;
export type ReceptionAdminControllerDownloadExcelV1QueryError = unknown;

export function useReceptionAdminControllerDownloadExcelV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
	TError = unknown
>(
	params: undefined | ReceptionAdminControllerDownloadExcelV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerDownloadExcelV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerDownloadExcelV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerDownloadExcelV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerDownloadExcelV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 참가자 명단 엑셀 다운로드
 */

export function useReceptionAdminControllerDownloadExcelV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>,
	TError = unknown
>(
	params?: ReceptionAdminControllerDownloadExcelV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerDownloadExcelV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getReceptionAdminControllerDownloadExcelV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 대회/프로그램 회차 참가자 명단(체크인 상태 포함). 관리자가 마스킹 해제 권한(POST /admin/unmask)을 보유한 동안 이름/전화번호가 자동으로 마스킹 해제되어 반환됨
 * @summary 참가자 명단
 */
export const receptionAdminControllerGetParticipantsV1 = (
	params?: ReceptionAdminControllerGetParticipantsV1Params,
	signal?: AbortSignal
) => {
	return axiosInstance<ParticipantListResponseDto>({ url: `/v1/admin/reception/participants`, method: 'GET', params, signal });
};

export const getReceptionAdminControllerGetParticipantsV1QueryKey = (params?: ReceptionAdminControllerGetParticipantsV1Params) => {
	return [`/v1/admin/reception/participants`, ...(params ? [params] : [])] as const;
};

export const getReceptionAdminControllerGetParticipantsV1QueryOptions = <
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetParticipantsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getReceptionAdminControllerGetParticipantsV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>> = ({ signal }) =>
		receptionAdminControllerGetParticipantsV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReceptionAdminControllerGetParticipantsV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>
>;
export type ReceptionAdminControllerGetParticipantsV1QueryError = void;

export function useReceptionAdminControllerGetParticipantsV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
	TError = void
>(
	params: undefined | ReceptionAdminControllerGetParticipantsV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetParticipantsV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetParticipantsV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
					TError,
					Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useReceptionAdminControllerGetParticipantsV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetParticipantsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 참가자 명단
 */

export function useReceptionAdminControllerGetParticipantsV1<
	TData = Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>,
	TError = void
>(
	params?: ReceptionAdminControllerGetParticipantsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionAdminControllerGetParticipantsV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getReceptionAdminControllerGetParticipantsV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 대회 예약/프로그램 참가를 수동 체크인 처리. 단체 멤버는 id에 "member-{memberId}" 형태(참가자 명단 API가 반환하는 id 그대로)를 전달하면 kind=CONTEST로 처리됩니다.
 * @summary 관리자 수동 체크인
 */
export const receptionAdminControllerManualCheckInV1 = (id: string, manualCheckInDto: ManualCheckInDto, signal?: AbortSignal) => {
	return axiosInstance<CheckInMutationResponseDto>({
		url: `/v1/admin/reception/${id}`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: manualCheckInDto,
		signal
	});
};

export const getReceptionAdminControllerManualCheckInV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>,
		TError,
		{ id: string; data: ManualCheckInDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>,
	TError,
	{ id: string; data: ManualCheckInDto },
	TContext
> => {
	const mutationKey = ['receptionAdminControllerManualCheckInV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>,
		{ id: string; data: ManualCheckInDto }
	> = props => {
		const { id, data } = props ?? {};

		return receptionAdminControllerManualCheckInV1(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReceptionAdminControllerManualCheckInV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>
>;
export type ReceptionAdminControllerManualCheckInV1MutationBody = ManualCheckInDto;
export type ReceptionAdminControllerManualCheckInV1MutationError = void;

/**
 * @summary 관리자 수동 체크인
 */
export const useReceptionAdminControllerManualCheckInV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>,
			TError,
			{ id: string; data: ManualCheckInDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof receptionAdminControllerManualCheckInV1>>,
	TError,
	{ id: string; data: ManualCheckInDto },
	TContext
> => {
	return useMutation(getReceptionAdminControllerManualCheckInV1MutationOptions(options), queryClient);
};
/**
 * 체크인 상태를 취소하고 사유를 기록. 단체 멤버는 id에 "member-{memberId}" 형태(참가자 명단 API가 반환하는 id 그대로)를 전달하면 kind=CONTEST로 처리됩니다.
 * @summary 관리자 체크인 취소
 */
export const receptionAdminControllerCancelCheckInV1 = (id: string, checkInCancelDto: CheckInCancelDto, signal?: AbortSignal) => {
	return axiosInstance<CheckInMutationResponseDto>({
		url: `/v1/admin/reception/${id}/cancel`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: checkInCancelDto,
		signal
	});
};

export const getReceptionAdminControllerCancelCheckInV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>,
		TError,
		{ id: string; data: CheckInCancelDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>,
	TError,
	{ id: string; data: CheckInCancelDto },
	TContext
> => {
	const mutationKey = ['receptionAdminControllerCancelCheckInV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>,
		{ id: string; data: CheckInCancelDto }
	> = props => {
		const { id, data } = props ?? {};

		return receptionAdminControllerCancelCheckInV1(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReceptionAdminControllerCancelCheckInV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>
>;
export type ReceptionAdminControllerCancelCheckInV1MutationBody = CheckInCancelDto;
export type ReceptionAdminControllerCancelCheckInV1MutationError = void;

/**
 * @summary 관리자 체크인 취소
 */
export const useReceptionAdminControllerCancelCheckInV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>,
			TError,
			{ id: string; data: CheckInCancelDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof receptionAdminControllerCancelCheckInV1>>,
	TError,
	{ id: string; data: CheckInCancelDto },
	TContext
> => {
	return useMutation(getReceptionAdminControllerCancelCheckInV1MutationOptions(options), queryClient);
};
/**
 * 대회/프로그램 업로드용 엑셀 양식(헤더+예시행) 다운로드
 * @summary 현장 접수 엑셀 양식 다운로드
 */
export const onsiteUploadControllerDownloadTemplateV1 = (params: OnsiteUploadControllerDownloadTemplateV1Params, signal?: AbortSignal) => {
	return axiosInstance<void>({ url: `/v1/admin/reception/onsite/template`, method: 'GET', params, signal });
};

export const getOnsiteUploadControllerDownloadTemplateV1QueryKey = (params?: OnsiteUploadControllerDownloadTemplateV1Params) => {
	return [`/v1/admin/reception/onsite/template`, ...(params ? [params] : [])] as const;
};

export const getOnsiteUploadControllerDownloadTemplateV1QueryOptions = <
	TData = Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
	TError = unknown
>(
	params: OnsiteUploadControllerDownloadTemplateV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getOnsiteUploadControllerDownloadTemplateV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>> = ({ signal }) =>
		onsiteUploadControllerDownloadTemplateV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OnsiteUploadControllerDownloadTemplateV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>
>;
export type OnsiteUploadControllerDownloadTemplateV1QueryError = unknown;

export function useOnsiteUploadControllerDownloadTemplateV1<
	TData = Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
	TError = unknown
>(
	params: OnsiteUploadControllerDownloadTemplateV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
					TError,
					Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOnsiteUploadControllerDownloadTemplateV1<
	TData = Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
	TError = unknown
>(
	params: OnsiteUploadControllerDownloadTemplateV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
					TError,
					Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOnsiteUploadControllerDownloadTemplateV1<
	TData = Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
	TError = unknown
>(
	params: OnsiteUploadControllerDownloadTemplateV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 현장 접수 엑셀 양식 다운로드
 */

export function useOnsiteUploadControllerDownloadTemplateV1<
	TData = Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>,
	TError = unknown
>(
	params: OnsiteUploadControllerDownloadTemplateV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof onsiteUploadControllerDownloadTemplateV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getOnsiteUploadControllerDownloadTemplateV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 기가입 회원 대상 현장 결제/초대 참가자 생성
 * @summary 현장 접수 엑셀 업로드
 */
export const onsiteUploadControllerUploadV1 = (
	onsiteUploadControllerUploadV1Body: OnsiteUploadControllerUploadV1Body,
	params: OnsiteUploadControllerUploadV1Params,
	signal?: AbortSignal
) => {
	const formData = new FormData();
	if (onsiteUploadControllerUploadV1Body.file !== undefined) {
		formData.append(`file`, onsiteUploadControllerUploadV1Body.file);
	}

	return axiosInstance<OnsiteUploadResponseDto>({
		url: `/v1/admin/reception/onsite/upload`,
		method: 'POST',
		headers: { 'Content-Type': 'multipart/form-data' },
		data: formData,
		params,
		signal
	});
};

export const getOnsiteUploadControllerUploadV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>,
		TError,
		{ data: OnsiteUploadControllerUploadV1Body; params: OnsiteUploadControllerUploadV1Params },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>,
	TError,
	{ data: OnsiteUploadControllerUploadV1Body; params: OnsiteUploadControllerUploadV1Params },
	TContext
> => {
	const mutationKey = ['onsiteUploadControllerUploadV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>,
		{ data: OnsiteUploadControllerUploadV1Body; params: OnsiteUploadControllerUploadV1Params }
	> = props => {
		const { data, params } = props ?? {};

		return onsiteUploadControllerUploadV1(data, params);
	};

	return { mutationFn, ...mutationOptions };
};

export type OnsiteUploadControllerUploadV1MutationResult = NonNullable<Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>>;
export type OnsiteUploadControllerUploadV1MutationBody = OnsiteUploadControllerUploadV1Body;
export type OnsiteUploadControllerUploadV1MutationError = void;

/**
 * @summary 현장 접수 엑셀 업로드
 */
export const useOnsiteUploadControllerUploadV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>,
			TError,
			{ data: OnsiteUploadControllerUploadV1Body; params: OnsiteUploadControllerUploadV1Params },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof onsiteUploadControllerUploadV1>>,
	TError,
	{ data: OnsiteUploadControllerUploadV1Body; params: OnsiteUploadControllerUploadV1Params },
	TContext
> => {
	return useMutation(getOnsiteUploadControllerUploadV1MutationOptions(options), queryClient);
};
